import gql from "graphql-tag";
import { useApolloClient } from "@apollo/react-hooks";

const recordArticleRatingMutation = gql`
  mutation recordArticleRating($articleId: ID!) {
    recordArticleRating(articleId: $articleId)
  }
`; 


export function useRecordArticleRating() {

  const client = useApolloClient();
  
  async function recordArticleRating(
    articleId: string
  ) {
    try {
      await client.mutate({
        mutation: recordArticleRatingMutation,
        variables: { articleId }
      });
    } catch (error) {}
  }

  return { recordArticleRating };
}
